import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Header from "./components/header";
import Footer from "./components/footer";
import Main from './pages/main';
import Contacts from './pages/contacts';
import Apply from './pages/apply';
import Blog from './pages/blog';
import Models from './pages/models';
import About from './pages/about';
import CalendlyPopup from './components/calendly-popup';
import { useState } from 'react';
import Privacy from './pages/privacy';
import Terms from './pages/terms';

function App() {

    const [showCalendly, setShowCalendly] = useState(false);

    const handleEnrollClick = (e) => {
        e.preventDefault();
        setShowCalendly(true);
    };

    return ( 
        <Router>
            <Header clickPopup={handleEnrollClick} />
            <CalendlyPopup show={showCalendly} onHide={() => setShowCalendly(false)} />
            <main>
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/apply" element={<Apply />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/contacts" element={<Contacts />} />
                    <Route path="/models" element={<Models />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                </Routes>
            </main>
            <Footer clickPopup={handleEnrollClick} />
        </Router>
     );
}

export default App;